const { ccclass } = cc._decorator;
import ModuleBase, { ViewLayer, bindButtonClickEvent, moduleInit } from "../../../../framework/core/mvvm/module_base";
import BankerListView from "./bankerlist_view";
import EventManager from "../../../../manager/event_manager";

@ccclass
@moduleInit("BankerListModule")
export default class BankerListModule extends ModuleBase<BankerListView, null>  {

    constructor() {
        super()
        this.layer = ViewLayer.Mid;
        this.windowPrefabResPath = 'package/table/banker_table';
        this.viewType = BankerListView;
        this.needViewMask = true
        this.clickAnywhereClose = false
        this.needViewBaseCloseBtn = true    
        this.needAnim = true
    }

    onShow(intentData){
        super.onShow(intentData);
        this.view.updateShow(intentData)
        this.bindEvent()
    }

    protected onButtonClickName(name : string) {
        switch (name) {
            case "GoBanterBtn":
                EventManager.instance.dispatch("event_req_banker")
                break;
            case "NoGoBanterBtn":
                EventManager.instance.dispatch("event_req_banker")
                break;
            case "FindSelfBtn":
                this.view.goFindMySelf()
                break
            default:
                break;
        }
    }

    @bindButtonClickEvent('closebtn')
    closebtn(){
        this.hide();
    }

    updateShow(datas:any){
        this.view.updateShow(datas)
    }

    private bindEvent() {
        this.eventBind("event_update_banker", this.updateShow);
    }

    onHide(){
        // let self = this
        this.eventUnBind("event_update_banker", this.updateShow);
    }

}